import fetch from 'isomorphic-fetch';
import { serverIp } from '@utils/constants';
import store from '@redux/Store.js';
import { logoutUserSuccess } from '@redux/actions/AuthActions';

export const createRequestHeaders = (customHeaders = []) => {
  const headers = new Headers();
  headers.append('Accept', 'application/json');
  headers.append('Content-Type', 'application/json');
  customHeaders.forEach(({ name, value }) => headers.append(name, value));
  return headers;
};

export const throwErrorOnNotOkStatus = response => {
  if (!response) {
    throw response.status;
  }
};

export const getResponseData = async res => {
  if (res.status === 204) {
    return null;
  }
  if (res.status === 401) {
    store.dispatch(logoutUserSuccess());
    return null;
  }
  const data = await res.text();
  return data && JSON.parse(data);
};

export const getResponseHeaders = res => {
  if (res.status === 204) {
    return {};
  }
  if (res.status === 401) {
    store.dispatch(logoutUserSuccess());
    return {};
  }
  const headerEntries = [...res.headers.entries()];
  return headerEntries.length > 0
    ? headerEntries.reduce((prev, [k, v]) => ({ ...prev, [k]: v }), {})
    : { 'content-type': 'application/json; charset=utf-8' };
};

const apiRequest = async (
  url,
  { method = 'GET', body, customHeaders = [] } = {}
) => {
  const content = {
    method,
    headers: createRequestHeaders([...customHeaders]),
    body: JSON.stringify(body)
  };

  const response = await fetch(`${serverIp}${url}`, content);

  throwErrorOnNotOkStatus(response);
  const data = await getResponseData(response);
  const responseHeaders = getResponseHeaders(response);
  return { data, responseHeaders };
};

export default apiRequest;
